import request from '../../utils/request';
import { Information } from '@/DTOS/CompanyInformation/Information';

const CompanyInformationService = {
  informations: (specification: Information) => {
    return request('/companyInformation/informations', {
      method: 'POST',
      body: JSON.stringify({ request: { ...specification } }),
    });
  },

  bank: (specification: Information) => {
    return request('/companyInformation/bank', {
      method: 'POST',
      body: JSON.stringify({ request: { ...specification } }),
    });
  },
};

export default CompanyInformationService;
